import React from 'react';
import { connect } from 'react-redux';
import PMO from "./PMO";
import ProjectManager from "./ProjectManager";
import Sponsor from "./Sponsor";
import SteeringCommittee from "./SteeringCommittee";
import Members from "./Members";

class Management extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: null,
            createMessage: false,
            createFail: null,
            isLoading: false
        }
    }

    

    render() {
        

        return (
            <div className='wizard-inside'>
                <PMO />
                <ProjectManager />
                <Sponsor />
                <SteeringCommittee />
                <Members />
            </div>
        );
    }
}

const mapActionToProp =
{
    // setCreated: addElement,
    // freeze: freezeWizard,
    // setNavigation
}

const mapStateToProps = state => ({
    // onPremise: state.newSite.OnPremiseState,
    // title: state.newSite.Title,
    // name: state.newSite.Name,
    // confidentiality: state.newSite.Confidentiality,
    // externalCollaboration: state.newSite.ExternalCollaboration,
    // quotaSize: state.newSite.QuotaSize,
    // postSuccess: state.response.Success,
    // geography: state.newSite.geography,
    // management: state.newSite.management,
    // created: state.newSite.OrderCreated,
    // purpose: state.newSite.Purpose,
    // gdpr: state.newSite.Gdpr,
    // sensitiveGdpr: state.newSite.SensitiveGdpr,
    // owner: state.newSite.Owner,
    // approver: state.newSite.Approver,
    // template: state.newSite.Template,
    // location: state.newSite.Location,
    // currentUser: state.user.currentUser,
    // isMsTeams: state.newSite.isMsTeams,
    // isMsTeamsApp: state.app.isMsTeamsApp
})

export default connect(mapStateToProps, mapActionToProp)(Management);







// WEBPACK FOOTER //
// ./src/components/CreateSite/Step5/Management.js